module.exports = __webpack_public_path__ + "static/pic02-908e6156ed09bb6782645f2c69675627.jpg";